import React, { useState } from "react";
import { Link, withRouter } from "react-router-dom";
import ImageLoader from "../../Common/ImageLoader";
import UpgradeProfilePopUp from "../../Common/Popups/UpgradeProfile";
import shortid from "shortid";
import VerifyProfile from "../Popups/VerifyProfile";
import ClaimProfile from "../Popups/ClaimProfile";
import RatingStart from "../RatingStarNew";
import { composeArrayForRatings } from "../CommonMethods";

const CompetitorBoxes = (props) => {
  const [isUpgrade, setUpgrade] = useState(false);
  const [isClaimProfile, setClaimProfile] = useState(false);

  const setClaimProfilePopUpFalse = () => {
    setClaimProfile(false);
  };

  return (
    <React.Fragment>
      {!!props.competitors && props.competitors.length > 0 ? (
        <>
          <div className="vendor_profile_sponsored_bottom_content_block">
            <div className="three_column_block">
              <ul>
                {!!props.competitors &&
                  props.competitors.length > 0 &&
                  props.competitors.map((competitor) => (
                    <li key={shortid.generate()}>
                      <div className="left">
                        <div className="logo_img">
                          <ImageLoader
                            image={competitor.logo}
                            fallbackImage={
                              "/static/images/FC-Generic-Logo.webp"
                            }
                            width={110}
                            height={40}
                          />
                        </div>

                        <div className="starRating">
                          <span className="txt">Reference Rating</span>
                          <RatingStart
                            starCount={composeArrayForRatings(
                              competitor?.rating?.aggregate_score
                            )}
                            profile
                            rated_by_user_count={
                              competitor?.rating?.rated_by_user_count
                            }
                            withoutO
                            useClass={"star"}
                          />

                          <span className="rating">4.7 / 5.0</span>
                        </div>
                        <div className="customer_references">
                          <span className="txt">Customer References</span>
                          <span className="total_customers">{`${competitor.reviews_count} total`}</span>
                        </div>
                      </div>
                      <div className="right">
                        <div className="text_block">
                          <h5>About</h5>
                          <p>{competitor.description}</p>
                        </div>
                        <div className="btn_profile">
                          <Link to={competitor.profile_url}>Visit profile</Link>
                        </div>
                      </div>
                    </li>
                  ))}
              </ul>
            </div>
            <div className="footer_text_block">
              {`Work at ${props.name} ? `}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  setClaimProfile(true);
                }}
              >
                Upgrade your profile
              </a>{" "}
              to unlock all your customer references and remove these
              competitors
            </div>
          </div>
        </>
      ) : (
        ``
      )}

      {isClaimProfile ? (
        // <UpgradeProfilePopUp
        //   companyName={props.name}
        //   companyId={props.company_id}
        //   setUpgrade={setUpgrade}
        // />
        <ClaimProfile setClaimProfilePopUpFalse={setClaimProfilePopUpFalse} />
      ) : (
        false
      )}
    </React.Fragment>
  );
};
const CompetitorBoxesWithRouter = withRouter(CompetitorBoxes);

export default CompetitorBoxesWithRouter;
